import ContactIdMappingListResourcePagingResultModel from '../../generated/types/model/resource/ContactIdMappingListResourcePagingResultModel';

export default class ContactIdMappingListResourcePagingResultViewModel extends ContactIdMappingListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
